import { gameState } from "appworks/model/game-state";
import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { TGRInstantWinResult } from "integration/builders/results/tgr-instant-win-result";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { LineResult } from "slotworks/model/gameplay/records/results/line-result";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export class IsTGRWin extends Decision {

    constructor(private includeQuickhit: boolean = true) {
        super();
    }

    public evaluate(): Exit {
        const currentGame: Gameplay = gameState.getCurrentGame();
        const record: SpinRecord | FreespinRecord = currentGame.getCurrentRecord() as SpinRecord | FreespinRecord;

        const hasLineWinsResults = this.hasLineWinResults(record);
        const hasFreespinWinResult = gameState.currentRecordHasFreespinWinResults() && !this.allFreespinsPlayed();
        const hasQuickhitResult = this.hasQuickhitResult(record);

        return hasLineWinsResults || hasFreespinWinResult || hasQuickhitResult ? Exit.True : Exit.False;
    }

    protected hasLineWinResults(record: SpinRecord | FreespinRecord): boolean {
        return record.getResultsOfType(LineResult).length > 0 ? true : false;
    }

    protected hasQuickhitResult(record: SpinRecord | FreespinRecord): boolean {
        const result: TGRInstantWinResult = record.getResultsOfType(TGRInstantWinResult)[0];
        return this.includeQuickhit && result?.cashWon > 0 ? true : false;
    }

    protected allFreespinsPlayed(): boolean {
        const currentGame: Gameplay = gameState.getCurrentGame();
        const record: SpinRecord | FreespinRecord = currentGame.getCurrentRecord() as SpinRecord | FreespinRecord;
        if (record.currentChildIndex === currentGame.getTotalFreespinsWon() - 1) {
            return true;
        }
        return false;
    }
}
